<div
  class="controls"
  filterDateValidator>
  <app-datepicker
    label="Choose a date"
    name="startDate"
    [(ngModel)]="filter.from"
    (ngModelChange)="updateFilterChangeTime()" />

  <span class="divider">-</span>

  <app-datepicker
    label="Choose a date"
    name="endDate"
    [(ngModel)]="filter.to"
    (ngModelChange)="updateFilterChangeTime()" />
</div>
